<nz-row
  class="lot-carousel-thumbs-actions"
  *ngIf="showExpandButton || downloadUrl"
  nzJustify="space-between"
  nzAlign="middle"
>
  <nz-col *ngIf="showExpandButton">
    <button
      nz-button
      nzType="primary"
      (click)="toggleExpand.emit()"
    >
      <ng-container *ngIf="!expanded">
        {{ 'AUTO_LOT.GUIDE.LOT_INSPECTION.SHOW_MORE' | translate }}
      </ng-container>
      <ng-container *ngIf="expanded">
        {{ 'AUTO_LOT.GUIDE.LOT_INSPECTION.SHOW_LESS' | translate }}
      </ng-container>
      <span nz-icon [nzType]="expanded ? 'up' : 'down'" class="ml-1"></span>
    </button>
  </nz-col>

  <nz-col *ngIf="downloadUrl">
    <a
      [href]="downloadUrl"
      nz-button
      nzType="link"
      download
    >
      {{ 'DOWNLOAD_ALL' | translate }}
      <span nz-icon nzType="download" class="ml-1"></span>
    </a>
  </nz-col>
</nz-row>
